<div class="ng-autocomplete w-100">  
    <ng-autocomplete 
      #searchInput
      [class]='classSearch'
      [data]="data"
      [searchKeyword]="keyword"
      placeholder="Buscar guía"
      (selected)='selectSearchGuide($event)'
      (inputChanged)='debouncedSearchInput($event)' 
      (inputCleared)='clearedInputSearch()'                              
      (closed)='closedSearchPanel()'                              
      [itemTemplate]="itemTemplate"
      [notFoundTemplate]="notFoundTemplate">                                 
    </ng-autocomplete>
    <ng-template #itemTemplate let-item>
      <a style="padding: 8px 15px 5px;" class="f-s-12 p-10" [innerHTML]="item.fullname"></a>
      <p style="padding: 0px 20px 5px; font-size: 9px !important; margin-bottom: 4px; margin-top: -5x;">
        <i class="fas fa-info-circle m-r-5"></i>DOC:
        <span [innerHTML]="item.document"></span>
        <ng-container *ngIf="item.reference_name != null">
          <span class="m-r-5 m-l-3">/</span>
          <span [innerHTML]="item.reference_name"></span>
        </ng-container>
      </p>
    </ng-template>   
    <ng-template #notFoundTemplate let-notFound>
      <p style="padding-top: 5px;
      margin-bottom: 5px;
      font-weight: 500;" *ngIf="isTypedSearch">No se encontraron registros</p>
    </ng-template>
</div>
